import styled from 'styled-components/macro';
import * as HoverCardPrimitive from '@radix-ui/react-hover-card';

export const HoverCardArrow = styled(HoverCardPrimitive.Arrow)`
  fill: ${({ theme }) => theme.colors.gray[7]};
  width: 12px;
  height: 6px;
  margin: 0 16px;
`;
